<template>
    <v-app style="background-color : #ecf0f1">
        <v-main>
            <v-container fluid bg fill-height grid-list-md text-xs-center>
                <Loader v-if="loader"></Loader>
                <v-col class="mx-auto" cols="12" lg="4" md="4" sm="7">
                    <v-card elevation="0"
                        style="border-radius: 70px 25px 70px 25px ;box-shadow: 44px 48px 0px 21px rgba(227,227,227,1) !important;">
                        <v-card-text>
                            <v-col cols="12" class="mx-auto text-center">
                                <v-img width="100" class="text-center mx-auto" src="/favicon.png"></v-img>
                            </v-col>
                            <v-form ref="form" v-on:submit.prevent="Login">
                                <h4 class="black--text mr-9 mt-8 font-bold">جهت ورود به سایت اطلاعات خود را وارد کنید
                                </h4>
                                <v-col class="pa-8 pa-0" cols="12">
                                    <v-text-field class="rounded-lg" background-color="white" solo ref="user"
                                        v-model="username" :rules="[requireRule]" append-icon="fas fa-user"
                                        label="نام کاربری">
                                        <template v-slot:append>
                                            <iconly name="profile" type="light" color="orange" />
                                        </template>
                                    </v-text-field>
                                    <v-text-field class="rounded-lg" background-color="white" :rules="[requireRule]"
                                        v-model="password" append-icon="fas fa-lock" type="password" label="رمز عبور"
                                        solo>
                                        <template v-slot:append>
                                            <iconly name="password" type="light" color="orange" />
                                        </template>
                                    </v-text-field>
                                    <v-btn type="submit" depressed class="white--text rounded-lg" width="100%"
                                        height="50" color="#02c9b7">ورود</v-btn>
                                </v-col>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data() {
            return {
                username: '',
                adminCode: '',
                enterCode: false,
                password: '',
                show1: false,
                loader: false,
                serial: '',
                showLicense: false
            }
        },
        methods: {
            copy() {
                navigator.clipboard.writeText(this.serial);
                this.$notify({
                    title: 'انجام شد',
                    text: 'کد کپی شد',
                    group: 'foo',
                    type: 'success',
                });
            },
            Login() {
                var valid = this.$refs.form.validate();
                if (!valid)
                    return;
                this.loader = true
                this.request({
                        method: 'post',
                        url: '/Login',
                        data: {
                            username: this.username,
                            password: this.password
                        }
                    })
                    .then((response) => {
                        localStorage.setItem("UserId", response.data.id);
                        localStorage.setItem("UserName", response.data.name);
                        this.setToken(response.data.token)
                        localStorage.setItem('userName' , response.data.name)
                        var nextUrl = this.$route.query.nextUrl
                        if (nextUrl)
                            this.$router.push(nextUrl)
                        else
                            this.$router.push("/dashboard");
                    })
                    .catch(error => {
                        if (error.status == 460) {
                            console.log(error.message)
                            this.serial = error.message.serial
                            this.showLicense = true
                        }
                    })
                    .finally(x => {
                        this.loader = false
                    })
            },
            sendCode() {
                if (this.adminCode == '') {
                    this.$notify({
                        title: 'خطا',
                        text: 'کد وارد نشده است',
                        group: 'foo',
                        type: 'error',
                    });
                    return;
                }
                this.loader = true
                this.request({
                        method: 'post',
                        url: '/check/serial',
                        data: {
                            serial: this.adminCode,
                        }
                    })
                    .then((response) => {
                        this.$notify({
                            title: 'انجام شد',
                            text: 'لایسنس شما با موفقیت تایید شد',
                            group: 'foo',
                            type: 'success',
                        });
                        this.request({
                            method: 'get',
                            url: '/update/customer'
                        })
                        this.request({
                            method: 'get',
                            url: '/get/limit'
                        })
                        this.adminCode = ''
                        this.sendCode = '',
                            this.showLicense = false
                        this.enterCode = false
                    })
                    .catch(error => {

                    })
                    .finally(x => {
                        this.loader = false
                    })
            }
        }
    }
</script>

<style lang="css">
    .rounded_shape {
        border-radius: 30% 70% 71% 29% / 48% 29% 71% 52%;
        height: 400;
    }
</style>
